import { FC } from 'react';
import { Action, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';
import { ProjectResponseDto } from '../../../store/landscapeAPI/project/dto/response/project-response.dto';
import { useNavigate, useParams } from 'react-router-dom';

export interface LandscapeProjectsOrganismProps {
  content: ProjectResponseDto[];
  handleDeleteProject: (id: string) => void;
}

const LandscapeProjectsOrganism: FC<LandscapeProjectsOrganismProps> = ({
  content,
  handleDeleteProject,
}) => {
  const navigate = useNavigate();

  const { id: landscapeId } = useParams();

  return (
    <SortableTable
      data={content}
      columns={[{ label: 'Project Name', key: 'name' }]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name}></Label>
          <Action
            type="edit"
            size="sm"
            onClick={() =>
              navigate(
                `/landscapes/edit/${landscapeId}/projects/add-project/${row.id}/basic-information`
              )
            }
          ></Action>
          <Action
            type="delete"
            size="sm"
            onClick={() => handleDeleteProject(row.id)}
          ></Action>
        </TableRow>
      )}
    />
  );
};

export default LandscapeProjectsOrganism;
